import React, { useCallback } from 'react';
import { Grid } from '@mui/material';
import TextField from 'libs/formik_fields/TextField';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import FormikFormWrapper from 'libs/formik_fields/FormikFormWrapper';
import { LoadingButton } from '@mui/lab';
import SingleFileUploadField from 'libs/formik_fields/SingleFileUploadField';

const emptyProfile = {
    name: '',
    contactNumber: null,
    image: { url: '', key: '', new: false, loading: false }
};

const changePasswordSchema = yup.object().shape({
    name: yup.string().required('Please enter name of user.'),
    // contactNumber: yup.string().required('Please enter contact number.').max(10, 'Contact number must be 10 digits.'),
    image: yup.mixed().required('Please add image.')
});

const useStyles = makeStyles((theme) => ({
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}));

const UserProfileFormContent = (formik) => {
    const { isSubmitting } = formik;

    const navigate = useNavigate();

    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <TextField name="name" label="Name*" />
                <TextField name="contactNumber" label="Contact No" />
                <SingleFileUploadField name="image" label="Image" accept="image/*" fileType="image" />
            </Grid>
            <Grid item xs={12} style={{ paddingTop: 0 }}>
                <LoadingButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    disableElevation
                    loading={isSubmitting}
                    loadingPosition="center"
                >
                    Save
                </LoadingButton>
            </Grid>
        </Grid>
    );
};

function UserProfileForm({ handleSubmit, initialValues }) {
    return (
        <FormikFormWrapper
            initialValues={initialValues ?? emptyProfile}
            onSubmit={handleSubmit}
            validationSchema={changePasswordSchema}
            FormContent={UserProfileFormContent}
        />
    );
}

export default UserProfileForm;
